module.exports = __webpack_public_path__ + "img/ukeyBox.f988313e.png";